<template>
  <v-app
    id="materialpro"
    :class="
      `${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`
    "
  >
    <notifications position="top right" width="50%" class="mt-20">
      <template slot="body" slot-scope="props">
        <div
          class="custom-template warning d-flex"
          v-if="props.item.type == 'warning'"
        >
          <div class="custom-template-icon">
            <v-icon color="#fff">mdi-checkbox-marked-circle-outline</v-icon>
          </div>
          <div class="custom-template-content">
            <div class="custom-template-title">
              {{ props.item.title }}
            </div>
            <div class="custom-template-text" v-html="props.item.text"></div>
          </div>
          <div class="custom-template-close ml-auto" @click="props.close">
            <v-icon color="#fff">mdi-close</v-icon>
          </div>
        </div>

        <div
          class="custom-template error d-flex"
          v-if="props.item.type == 'error'"
        >
          <div class="custom-template-icon">
            <v-icon color="#fff">mdi-checkbox-marked-circle-outline</v-icon>
          </div>
          <div class="custom-template-content">
            <div class="custom-template-title">
              {{ props.item.title }}
            </div>
            <div class="custom-template-text" v-html="props.item.text"></div>
          </div>
          <div class="custom-template-close ml-auto" @click="props.close">
            <v-icon color="#fff">mdi-close</v-icon>
          </div>
        </div>
        <div
          class="custom-template success d-flex"
          v-if="props.item.type == 'success'"
        >
          <div class="custom-template-icon">
            <v-icon color="#fff">mdi-checkbox-marked-circle-outline</v-icon>
          </div>
          <div class="custom-template-content">
            <div class="custom-template-title">
              {{ props.item.title }}
            </div>
            <div class="custom-template-text" v-html="props.item.text"></div>
          </div>
          <div class="custom-template-close ml-auto" @click="props.close">
            <v-icon color="#fff">mdi-close</v-icon>
          </div>
        </div>
      </template>
    </notifications>
    <router-view />
  </v-app>
</template>

<script>
import store from "./store";

export default {
  name: "App",
  components: {},
  created() {
    // 사용자가 창을 닫을 경우, online table에서 삭제하기 위해 이벤트 처리.
    window.addEventListener("beforeunload", this.closeWindow);
  },
  methods: {
    async closeWindow() {
      await store.dispatch("offline");
    }
  }
};
</script>
<style lang="scss">
.custom-template {
  // display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  text-align: left;
  font-size: 13px;
  margin: 5px;
  margin-bottom: 0;
  align-items: center;
  border-radius: 8px;
  color: #fff;
  justify-content: center;
  &,
  & > div {
    box-sizing: border-box;
  }

  .custom-template-icon {
    // flex: 0 1 auto;
    padding: 0 10px;
  }
  .custom-template-close {
    // flex: 0 1 auto;
    padding: 0 20px;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .custom-template-content {
    padding: 10px;
    // flex: 1 0 auto;
    .custom-template-title {
      letter-spacing: 1px;
      text-transform: uppercase;
      font-size: 10px;
      font-weight: 600;
    }
  }
}
.mt-20 {
  margin-top: 160px;
}
</style>
